import { apiSlice } from 'state/slices/apiSlice';

const ROLES_URL = '/roles';

export const roleApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createRole: builder.mutation({
      query: (roleData) => ({
        url: `${ROLES_URL}/create`,
        method: 'POST',
        body: roleData,
        transformResponse: (response) => response.json(),
      }),
    }),
    getRoles: builder.query({
      query: () => `${ROLES_URL}/list`,
    }),
    updateRole: builder.mutation({
      query: ({ id, data }) => {
        return {
          url: `${ROLES_URL}/update`,
          method: 'PUT',
          body: { id, ...data },
        };
      },
    }),
    deleteRole: builder.mutation({
      query: (id) => ({
        url: `${ROLES_URL}/delete`,
        method: 'DELETE',
        body: { id }
      }),
    }),
  }),
});

export const {
  useCreateRoleMutation,
  useGetRolesQuery,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
} = roleApiSlice;
